import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_get_count_tasks_by_chainheadService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { chainhead: number }): 
  Promise<{ result: { Id?: number, OperationCodeId?: number, StatusId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.chainhead)) {
      $missingRequiredInParams.push('\'chainhead\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { chainhead: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, OperationCodeId?: number, StatusId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.chainhead)) {
      $missingRequiredInParams.push('\'chainhead\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { chainhead: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, OperationCodeId?: number, StatusId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.chainhead)) {
      $missingRequiredInParams.push('\'chainhead\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      chainhead: number    }) {
        if(isNil($inParams.chainhead)) {
          return true; 
        }
      return false;
    }
}
